module.exports = __webpack_public_path__ + "img/46.453834b2.jpg";